import React, { Component } from "react";
import { connect } from "react-redux";
import * as types from "constants/actionTypes";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

class DatePickerCalendarInput extends Component {
  constructor(props) {
    super(props);

    if (props.value)
      //if store has value relative to this component, initialize the state value
      this.state = { value: props.value, error: "" };
    //in case the store does not have any value for this component, just clear it
    else this.state = { value: "", error: "" };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value && newProps.value !== this.state.value)
      //if store's value relative to this component change, update the state value
      this.setState({ value: newProps.value });
    else if (!newProps.value)
      //in case the store does not have any value for this component, just clear it
      this.setState({ value: "" });

    if (newProps.error && newProps.error !== this.state.error)
      this.setState({ error: newProps.error });
  }

  onChange = (event, value) => {
    this.updateStore(event.target.value);
  };

  updateStore(value) {
    this.setState({ value });
    this.props.dispatch({
      type: types.FORM_INPUT,
      value,
      name: this.props.name
    });
  }

  render() {
    const p = this.props;
    const e = this.state && this.state.error;
    const componentValue = this.state && this.state.value;
    const { label, floatingLabelText, error, dispatch, width, ...datepickerProps } = { ...p };

    return (
      <div className="form-group">
        <FormControl className={p.className} fullWidth>
          <TextField
            {...datepickerProps}
            floatingLabelFixed={true}
            type="date"
            onChange={this.onChange}
            onKeyDown={p.preventTyping? (e) => e.preventDefault(): undefined}
            style={width ? { width: width } : {}}
            label={label || floatingLabelText}
            value={this.state.value !== "" ? this.state.value.slice(0, 10) : ""}
            errorText={!componentValue && error}
            variant="standard"
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    value: state.form[props.name],
    error: state.form && state.form.error && state.form.error[props.name]
  };
};

export default connect(mapStateToProps)(DatePickerCalendarInput);
